import { render } from "./OverviewPage.vue?vue&type=template&id=57829b90&scoped=true"
import script from "./OverviewPage.vue?vue&type=script&lang=js"
export * from "./OverviewPage.vue?vue&type=script&lang=js"

import "./OverviewPage.vue?vue&type=style&index=0&id=57829b90&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57829b90"]])

export default __exports__